// What the procurement page (pages/products.tsx) reads, and so what it must refetch
// once a change made from it lands. An item's colour (pending / short / booked /
// procured) compares two numbers from two queries:
//   - ordered:  the window's order lines, under "/api/orders"
//   - procured: the per-window aggregate (product_procurement), under "/api/procurement"
// Refetching only one leaves the item showing the old state until the page's 30 s poll.
import type { QueryClient } from "@tanstack/react-query";

/**
 * Key prefixes, so every window's query is covered whatever its params. Editing an
 * order line never writes product_procurement on the server, and setting procured
 * never writes an order line — but either moves the comparison, so both refetch.
 */
export const PROCUREMENT_PAGE_STALE_KEYS = ["/api/orders", "/api/procurement", "/api/dashboard/stats"] as const;

export function refreshProcurementPage(queryClient: QueryClient): void {
  for (const key of PROCUREMENT_PAGE_STALE_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
